/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetInvoicesZipInvoice } from './GetInvoicesZipInvoice';
import {
    GetInvoicesZipInvoiceFromJSON,
    GetInvoicesZipInvoiceFromJSONTyped,
    GetInvoicesZipInvoiceToJSON,
    GetInvoicesZipInvoiceToJSONTyped,
} from './GetInvoicesZipInvoice';

/**
 * 
 * @export
 * @interface GetInvoicesZipRequest
 */
export interface GetInvoicesZipRequest {
    /**
     * 
     * @type {string}
     * @memberof GetInvoicesZipRequest
     */
    shipmentId: string;
    /**
     * 
     * @type {Array<GetInvoicesZipInvoice>}
     * @memberof GetInvoicesZipRequest
     */
    invoices: Array<GetInvoicesZipInvoice>;
}

/**
 * Check if a given object implements the GetInvoicesZipRequest interface.
 */
export function instanceOfGetInvoicesZipRequest(value: object): value is GetInvoicesZipRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('invoices' in value) || value['invoices'] === undefined) return false;
    return true;
}

export function GetInvoicesZipRequestFromJSON(json: any): GetInvoicesZipRequest {
    return GetInvoicesZipRequestFromJSONTyped(json, false);
}

export function GetInvoicesZipRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInvoicesZipRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
        'invoices': ((json['invoices'] as Array<any>).map(GetInvoicesZipInvoiceFromJSON)),
    };
}

  export function GetInvoicesZipRequestToJSON(json: any): GetInvoicesZipRequest {
      return GetInvoicesZipRequestToJSONTyped(json, false);
  }

  export function GetInvoicesZipRequestToJSONTyped(value?: GetInvoicesZipRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
        'invoices': ((value['invoices'] as Array<any>).map(GetInvoicesZipInvoiceToJSON)),
    };
}

